module.exports = __webpack_public_path__ + "static/media/mypic.23ca979a.jpg";